import { Box, FlexColumn, FlexRow, SearchTextField } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FC } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import { CustomViewDialogFavorites } from "./CustomViewDialogFavorites";
import { ViewAccordionForPublic } from "./CustomViewDialogLeftPanelAccordion";
import CustomViewDialogPersonalViews from "./CustomViewDialogPersonalViews";
import CustomViewDialogRoleBasedViews from "./CustomViewDialogRoleBasedViews";

const CustomViewDialogLeftPanel: FC<{}> = observer(() => {
	const { customViewStore: { setSearchText, searchText } } = useCustomViewDialogStore();
	return (
		<FlexColumn 
			bgcolor={grey[50]}
			data-csi-automation="LeftPane"
		>
			<Box px={6} py={2}>
				<FlexRow>
					<SearchTextField
						data-csi-automation="SearchForView"
						onChange={(event) => setSearchText(event.target.value)}
						placeholderRes="CustomViewSearch"
						sx={{
							width: 248,
						}}
						value={searchText}
					/>
				</FlexRow>
			</Box>
			<FlexRow growNoOverflow>
				<FlexColumn 
					data-csi-automation="ViewList"
					overflow="hidden scroll" 
					width={1}
				>
					<CustomViewDialogFavorites />
					<ViewAccordionForPublic />
					<CustomViewDialogRoleBasedViews />
					<CustomViewDialogPersonalViews />
					<FlexRow flexGrow={1} />
					{/* TBD in 7.10 <FlexRowCenter
						borderTop={STANDARD_BORDER_STYLE}
						flexShrink={0}
						height={44}
					>
						<Button
							design="link"
							fullWidth
							res="CustomViewCreateNewView"
							sx={{ fontWeight: FONT_SEMIBOLD }}
						/>
					</FlexRowCenter> */}
				</FlexColumn>
			</FlexRow>
		</FlexColumn>
	);
});

export default CustomViewDialogLeftPanel;